<template>
  <div class="result-pg">
    <progress-bar/>

    <div class="input-form">
      <span class="title">Your recommended sizes</span>
      <div class="progress-circles-row">
        <progress-ring v-if="primaryIsShown" class="first-recommendation" :recommendation="results.primary"/>

        <progress-ring v-if="results.secondary.size && secondaryIsShown" class="second-recommendation" :recommendation="results.secondary"/>
      </div>
      <div class="result-text-row row">
        <p>This recommendation is based on the size that <b>people like you bought</b>, and whether they returned it.</p>
        <p v-if="primaryIsShown">
          Based on the purchases of thousands of similar shoppers,
          there is a <b>{{ results.primary.confidence }}% chance</b>
          that you will be happy with size {{ results.primary.size }}.
        </p>
      </div>
    </div>

    <div class="footer-navigation">
      <div class="back-step-btn" @click="startAgain">Start again</div>
      <div class="continue-shopping-btn" @click="continueShopping">Continue shopping</div>
    </div>
  </div>
</template>

<script>
import ProgressBar from "../../ProgressBar";
import ProgressRing from "./result/ProgressRing";
import VueService from "../../../services/vue/VueService";
import {mapGetters} from 'vuex';
import CustomEvents from "../../../services/CustomEvents";
import ConfigurationService from "../../../services/ConfigurationService";
import Amplitude from '../../../plugins/Amplitude';

export default {
  name: "ResultView",

  components: {ProgressRing, ProgressBar},

  data() {
    return {
      primaryIsShown: null,
      secondaryIsShown: null,
    };
  },

  computed: {
    ...mapGetters({
      results: 'results/get',
    }),
  },

  mounted() {
    CustomEvents.trigger('wizardWasCompleted'); // keeping this for backward compatibility
    CustomEvents.trigger('recommendationGiven');
    Amplitude.logEvent('recommendation given');

    this.shouldShowResult('primary');
    this.shouldShowResult('secondary');

    // show primary if both are not available
    if (this.primaryIsShown === false && this.secondaryIsShown === false) {
      this.primaryIsShown = true;
    }
  },

  methods: {
    shouldShowResult(primarySecondary) {
      const size = this.results[primarySecondary].size;
      const availableSizes = ConfigurationService.getAvailableSizes();

      // don't show XS for hoodies
      const showXsForHoodies = !(size === 'XS' && ConfigurationService.getCurrentType() === 'hoodies');

      // hide unavailable sizes
      let sizeIsAvailable = (availableSizes.length === 0) || availableSizes.includes(size);

      this[primarySecondary + 'IsShown'] = showXsForHoodies && sizeIsAvailable;
    },

    startAgain() {
      this.$store.commit('userSelections/reset');
      this.$store.commit('navigation/startAgain');
    },

    continueShopping() {
      VueService.close();
    },
  },
};
</script>
